// @ts-nocheck
import React from 'react';

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '../../../components/ui/accordion';

interface FAQSectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const FAQSection: React.FC<FAQSectionProps> = ({ sectionId, sectionData, ...extraProps }) => {
  return (
    <section id={sectionId} className="container px-4 md:px-6 py-16 lg:py-24">
      <div className="flex w-full flex-col items-center justify-center text-center mb-10">
        <p className="pb-3 font-bold text-destructive text-sm tracking-wide uppercase">FAQ</p>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
          Frequently Asked <span className="text-primary underline underline-offset-4">Questions</span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto bg-background rounded-2xl border p-6 lg:p-10 box-shadow-card">
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="pricing" data-testid="faq-item-pricing">
            <AccordionTrigger className="text-left text-base font-semibold" data-testid="faq-trigger-pricing">
              Is ActivityFox free to use for parents?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground font-medium">
              Yes! Browsing, searching, and using tools like Schedule Mode and the CampScout are completely free for parents. You only pay for the activities you book, at the price set by the provider.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="booking" data-testid="faq-item-booking">
            <AccordionTrigger className="text-left text-base font-semibold" data-testid="faq-trigger-booking">
              How does instant booking work?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground font-medium">
              When you find an activity you like, simply click "Book Now" and select your preferred session. Your spot is confirmed immediately — no waiting for callbacks or email confirmations. You'll receive an instant booking confirmation with all the details you need.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="cancellation" data-testid="faq-item-cancellation">
            <AccordionTrigger className="text-left text-base font-semibold" data-testid="faq-trigger-cancellation">
              What is the cancellation policy?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground font-medium">
              Cancellation policies vary by activity provider. You can view each provider's specific policy on their activity page before booking. Most providers offer free cancellation up to 24–48 hours before the session starts.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="planner" data-testid="faq-item-planner">
            <AccordionTrigger className="text-left text-base font-semibold" data-testid="faq-trigger-planner">
              How does the CampScout work?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground font-medium">
              The CampScout helps you build a conflict-free summer camp schedule. Pick the camps your kids love, set your family's preferences (like avoiding overlaps or morning-only sessions), and we'll generate an optimized week-by-week plan. You can adjust and commit when you're happy with it.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="verification" data-testid="faq-item-verification">
            <AccordionTrigger className="text-left text-base font-semibold" data-testid="faq-trigger-verification">
              How are activity providers verified?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground font-medium">
              All providers go through a verification process before their activities are listed. We check business licensing, insurance, and background information. Verified providers display a trust badge on their profile, so you can book with confidence.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="account" className="border-b-0" data-testid="faq-item-account">
            <AccordionTrigger className="text-left text-base font-semibold" data-testid="faq-trigger-account">
              Do I need an account to browse activities?
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground font-medium">
              You can browse and search activities without an account. However, you'll need to sign up (it's quick and free) to book activities, save favorites, use the CampScout, and manage your family's schedule.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
